<div class="card flex justify-content-center">
    <p-confirmDialog
        [key]="key"
        #cd
        [style]="style">
        <ng-template #header>
            <div
                class="sera__confirmation__line-header"
                [style.backgroundColor]="dialogHeaderColor"></div>
            <div class="sera__confirmation__header">
                <div class="sera__confirmation__header_left_content">
                    <i
                        *ngIf="showtitleIcon"
                        style="font-size: 24px"
                        class="{{ headerIcon }}"></i>
                    <h3>{{ title | translate }}</h3>
                    <h3 *ngIf="isWithUUID">({{ cd.confirmation!.header }})</h3>
                </div>
            </div>
        </ng-template>
        <ng-template #message>
            <div
                class="p-confirm-dialog-message"
                [ngClass]="{ 'with-checkbox': showDoNotShowAgain }">
                <span *ngIf="!innerHtmlMessage">
                    {{ messageToShow ? (messageToShow | translate) : (cd.confirmation?.message || '' | translate) }}
                </span>

                <div
                    *ngIf="innerHtmlMessage"
                    [innerHTML]="messageToShow ? messageToShow : cd.confirmation?.message"></div>

                <ds-checkbox-group
                    class="p-confirm-dialog-checkbox-group"
                    *ngIf="showDoNotShowAgain">
                    <input
                        [(ngModel)]="doNotShowAgainChecked"
                        ds-input
                        id="doNotShowAgain"
                        type="checkbox"
                        name="position"
                        value="1" />
                    <label
                        ds-label
                        for="doNotShowAgain">
                        {{ 'PAGE.GENERAL.DO_NOT_SHOW_AGAIN.LBL' | translate }}
                    </label>
                </ds-checkbox-group>
            </div>
        </ng-template>

        <ng-template #footer>
            <ds-button
                *ngIf="!hideSecondaryButton"
                [variant]="isToHaveTwoPrimaryButtons ? dialogTertiaryButtonVariant : dialogSecondaryButtonVariant"
                (click)="isToHaveTwoPrimaryButtons ? cd.close() : cd.onReject()"
                (keyup.enter)="isToHaveTwoPrimaryButtons ? cd.close() : cd.onReject()">
                {{ secondaryButtonLabel | translate }}
            </ds-button>
            <ds-button
                [variant]="!isToHaveTwoPrimaryButtons ? dialogPrimaryButtonVariant : dialogSecondaryButtonVariant"
                (click)="isToHaveTwoPrimaryButtons ? cd.onReject() : onAccept(cd)"
                (keyup.enter)="isToHaveTwoPrimaryButtons ? cd.onReject() : onAccept(cd)">
                {{ primaryButtonLabel | translate }}
            </ds-button>
            <ds-button
                *ngIf="isToHaveTwoPrimaryButtons"
                [variant]="dialogPrimaryButtonVariant"
                (click)="onAccept(cd)"
                (keyup.enter)="onAccept(cd)">
                {{ secondPrimaryButtonLabel | translate }}
            </ds-button>
        </ng-template>
    </p-confirmDialog>
</div>
